<template>
  <div class="outtie"></div>
</template>

<script>
export default {
  created() {
    this.$store
      .dispatch("destroySession")
      .then(() => {})
      .catch(() => {});
    this.$router.push("/login");
  }
};
</script>
